import BaseComponent from '../../../base/base_component';
import DOM from '../../../utils/dom';


let freePlayModeToggleHtml = require('../view/free-play-mode-toogles.html');

export default class FreePlayToggleNavbarPart extends BaseComponent {
    static CLASS = 'FreePlayToggleNavbarPart';

    init(params) {
        super.init(params);
        this._freePlayData = params.freePlayData;
        DOM.addClass(this.getEl(), 'cgp-navbar-toggle-wrapper');
        this.setInnerHtml(this.bake(freePlayModeToggleHtml));
        DOM.html(this._getFreePlayTitleById(), this.querySelector('.cgp-fp-game-toggle'))
    }



    _getFreePlayTitleById() {
        let title;

        switch (this._freePlayData.freePlayType) {
            case 1:
                title = 'free_play_voucher_title_fsv';
                break;
            case 2:
                title = 'free_play_voucher_title_fpv';
                break;
            case 3:
                title = 'free_play_voucher_title_jpfsv';
                break;
            case 4:
                title = 'free_play_voucher_title_jpfpv';
                break;
            default:
                this.logger.error('freePlayID ' + this._freePlayData.freePlayType + ' is not exists');
        }

        return this.serviceFactory.languageService().translation(title);
    }
}